import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ShieldCheckIcon, LockIcon, StarIcon, CheckCircle2Icon } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden bg-black" data-id="element-202">
      {/* Ambient Light */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[400px] bg-yellow-500/10 blur-[120px] rounded-full pointer-events-none" data-id="element-203" />

      <div className="max-w-7xl mx-auto px-4 relative z-10" data-id="element-204">
        <div className="flex flex-col items-center text-center" data-id="element-205">
          {/* Badge */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="inline-flex flex-wrap justify-center items-center gap-1.5 px-4 py-2 rounded-full border border-yellow-500/30 bg-yellow-500/10 text-yellow-500 text-[10px] md:text-sm font-bold uppercase tracking-widest mb-8 text-center max-w-[95vw]" data-id="element-206">
            <span data-id="element-207">🎓</span>
            <span data-id="element-208">PARA DOCENTES DE ARGENTINA</span>
            <span className="hidden md:inline" data-id="element-209">—</span>
            <span data-id="element-210">
              Inicial · Primaria · Secundaria · Terciario · Universitario
            </span>
          </motion.div>

          {/* H1 Title — FIRST */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-4xl md:text-6xl lg:text-7xl font-black uppercase tracking-tight text-white mb-10 max-w-5xl leading-[1.1]" data-id="element-211">
            Dejá de Perder tus{' '}
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-yellow-400 to-yellow-600" data-id="element-212">
              Fines de Semana
            </span>{' '}
            Planificando desde Cero.
          </motion.h1>

          {/* Product Image — RIGHT AFTER TITLE */}
          <div className="mb-12 relative w-full max-w-4xl mx-auto" data-id="element-213">
            <div className="absolute inset-0 bg-yellow-500/20 blur-3xl rounded-full" data-id="element-214" />
            <img src="https://cdn.magicpatterns.com/uploads/baUxQRRPJNXGcYGntg8m1H/heylloyd-image-1773076189036.jpg" alt="Sistema de Productividad Docente" className="relative z-10 w-full h-auto rounded-xl border border-zinc-800 shadow-2xl" loading="eager" decoding="async" fetchPriority="high" width={1408} height={768} sizes="(max-width: 768px) 100vw, (max-width: 1024px) 80vw, 896px" data-id="element-215" />
          </div>

          {/* Subtitle */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.35
        }} className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto mb-10" data-id="element-216">
            Aprendé el sistema exacto para crear planificaciones, actividades y
            evaluaciones con IA en 10 minutos. Una sola vez. Para siempre.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="flex flex-wrap justify-center gap-2 mb-6 text-xs md:text-sm font-semibold text-yellow-500/90 uppercase tracking-wide" data-id="element-217">
            <span data-id="element-218">✅ Cualquier materia</span>
            <span className="text-zinc-600" data-id="element-219">·</span>
            <span data-id="element-220">
              Inicial · Primaria · Secundaria · Terciario · Universitario
            </span>
          </motion.div>

          {/* CTA Button */}
          <motion.button initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.45
        }} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={scrollToPricing} className="group relative inline-flex items-center justify-center gap-3 bg-yellow-500 text-black font-black uppercase px-8 py-4 md:px-12 md:py-5 rounded-full text-lg md:text-xl shadow-[0_0_30px_rgba(234,179,8,0.4)] hover:shadow-[0_0_40px_rgba(234,179,8,0.6)] transition-all" data-id="element-221">
            QUIERO MI SISTEMA AHORA
            <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-222" />
          </motion.button>

          {/* Trust Badges */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.55
        }} className="flex flex-wrap justify-center items-center gap-4 md:gap-8 mt-8 text-sm text-gray-400" data-id="element-223">
            <div className="flex items-center gap-1.5" data-id="element-224">
              <LockIcon className="w-4 h-4 text-gray-500" data-id="element-225" /> Pago 100% Seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-226">
              <CheckCircle2Icon className="w-4 h-4 text-green-500" data-id="element-227" /> Acceso
              Inmediato
            </div>
            <div className="flex items-center gap-1.5" data-id="element-228">
              <ShieldCheckIcon className="w-4 h-4 text-yellow-500" data-id="element-229" /> Garantía 7
              días
            </div>
            <div className="flex items-center gap-1.5 font-medium text-gray-300" data-id="element-230">
              🇦🇷 Hecho para Argentina
            </div>
          </motion.div>

          {/* Social Proof */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.65
        }} className="flex flex-col md:flex-row items-center gap-4 mt-12 pt-8 border-t border-zinc-900" data-id="element-231">
            <div className="flex -space-x-3" data-id="element-232">
              {['ML', 'CR', 'PM', 'GV', 'SA'].map((initials, i) => <div key={i} className="w-10 h-10 rounded-full bg-zinc-800 border-2 border-black flex items-center justify-center text-xs font-bold text-gray-300" data-id="element-233">
                  {initials}
                </div>)}
            </div>
            <div className="flex flex-col items-center md:items-start" data-id="element-234">
              <div className="flex gap-1 text-yellow-500 mb-1" data-id="element-235">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-236" />)}
              </div>
              <p className="text-sm text-gray-400" data-id="element-237">
                <span className="text-white font-bold" data-id="element-238">4.9/5</span> | +500
                docentes ya lo usan
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}